var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 2.87233C15.405 3.13333 14.771 3.30633 14.11 3.39033C14.79 2.98433 15.309 2.34633 15.553 1.57733C14.919 1.95533 14.219 2.22233 13.473 2.37133C12.871 1.73033 12.013 1.33333 11.077 1.33333C9.261 1.33333 7.799 2.80733 7.799 4.61433C7.799 4.87433 7.821 5.12433 7.875 5.36233C5.148 5.22933 2.735 3.92233 1.114 1.93133C0.831 2.42233 0.665 2.98433 0.665 3.58933C0.665 4.72533 1.25 5.73233 2.122 6.31533C1.595 6.30533 1.078 6.15233 0.64 5.91133C0.64 5.92133 0.64 5.93433 0.64 5.94733C0.64 7.54133 1.777 8.86533 3.268 9.17033C3.001 9.24333 2.71 9.27833 2.408 9.27833C2.198 9.27833 1.986 9.26633 1.787 9.22233C2.212 10.5213 3.418 11.4763 4.852 11.5073C3.736 12.3803 2.319 12.9063 0.785 12.9063C0.516 12.9063 0.258 12.8943 0 12.8613C1.453 13.7983 3.175 14.3333 5.032 14.3333C11.068 14.3333 14.368 9.33333 14.368 4.99933C14.368 4.85433 14.363 4.71433 14.356 4.57533C15.007 4.11333 15.554 3.53633 16 2.87233Z",
    fill: "#CCCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.fb8ec832fa1c40c1a667d4561ebdaeaf.svg";
export { ForwardRef as ReactComponent };